import React from "react";
import { Controller } from "react-hook-form";
import { Select, Form } from "antd";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";

const { Option } = Select;

const SortableSelect = ({ control, name, options, setValue, getValues }) => {
    const handleChange = (selected) => {
        const updatedSelected = selected
            .map((value) => {
                const option = options.find((opt) => opt.value === value);
                return option ? { value: option.value, label: option.label } : null;
            })
            .filter(Boolean);

        setValue(name, updatedSelected);
    };

    const onDragEnd = (result) => {
        if (!result.destination) return;

        const currentSelected = getValues(name) || [];
        const reorderedItems = Array.from(currentSelected);
        const [removed] = reorderedItems.splice(result.source.index, 1);
        reorderedItems.splice(result.destination.index, 0, removed);

        setValue(name, reorderedItems);
    };

    return (
        <Form.Item>
            <Controller
                control={control}
                name={name}
              
                render={({ field }) => {
                    const currentSelected = getValues(name) || [];
                    const selectedValues = currentSelected.map((item) => item.value);

                    return (
                        <>
                            <Select
                                {...field}
                                mode="multiple"
                                style={{ width: "100%" }}
                                placeholder="Select options"
                                onChange={handleChange}
                                value={selectedValues}
                            >
                                {options.map((option) => (
                                    <Option key={option.value} value={option.value}>
                                        {option.label}
                                    </Option>
                                ))}
                            </Select>

                            <DragDropContext onDragEnd={onDragEnd}>
                                <Droppable droppableId="selectedOptionsDroppable">
                                    {(provided) => (
                                        <div
                                            ref={provided.innerRef}
                                            {...provided.droppableProps}
                                            style={{
                                                marginTop: "10px",
                                                border: "1px solid #ccc",
                                                borderRadius: "4px",
                                                padding: "8px",
                                                background: "#f9f9f9",
                                            }}
                                        >
                                            {currentSelected.map((item, index) => (
                                                <Draggable
                                                    key={item.value}
                                                    draggableId={item.value}
                                                    index={index}
                                                >
                                                    {(provided) => (
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            style={{
                                                                padding: "8px",
                                                                marginBottom: "4px",
                                                                backgroundColor: "#fff",
                                                                border: "1px solid #ddd",
                                                                borderRadius: "4px",
                                                                ...provided.draggableProps.style,
                                                            }}
                                                        >
                                                            {item.label}
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))}
                                            {provided.placeholder}
                                        </div>
                                    )}
                                </Droppable>
                            </DragDropContext>
                        </>
                    );
                }}
            />
        </Form.Item>
    );
};

export default SortableSelect;
